import { Eye, Wind, Send } from "lucide-react";

const BG =
  "https://customer-assets.emergentagent.com/job_aerial-photo-book/artifacts/w82f8sf7_IMG_3357.jpeg";

export const Lookout = () => {
  return (
    <section
      id="lookout"
      data-testid="lookout-section"
      className="relative py-24 md:py-40 border-t border-white/5 overflow-hidden"
    >
      {/* Decorative bg */}
      <div className="absolute inset-0 -z-10">
        <img
          src={BG}
          alt=""
          aria-hidden="true"
          className="w-full h-full object-cover object-center opacity-20"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#05080F] via-[#05080F]/85 to-[#05080F]" />
      </div>

      <div className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-16">
        <div className="grid md:grid-cols-12 gap-12 md:gap-16 items-start">
          <div className="md:col-span-5">
            <span className="overline">§ 04 — Lookout</span>
            <h2 className="mt-6 text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight text-white leading-[0.95]">
              See a drone
              <br />
              over the lake?
              <br />
              <span className="text-[#E5A93B]">It might be us.</span>
            </h2>
          </div>

          <div className="md:col-span-7">
            <p className="text-lg md:text-xl text-white/80 leading-relaxed font-light">
              We don&apos;t only fly on schedule. Some of our best shots happen
              on quiet mornings and golden evenings when we&apos;re just out
              capturing the lake for fun.
            </p>
            <p className="mt-5 text-base text-white/60 leading-relaxed font-light">
              If you see our DJI buzzing above your cove, boat, or backyard —{" "}
              <span className="text-[#E5A93B]">give us a wave.</span> You might
              already be in a clip. Reach out and we&apos;ll send you the
              footage at a discounted price.
            </p>

            <div className="grid sm:grid-cols-3 gap-px bg-white/10 mt-10 border border-white/10">
              <Step
                icon={<Eye size={14} />}
                title="01 · Spot"
                body="A small drone overhead, mostly Lake Anna mornings & sunsets."
              />
              <Step
                icon={<Wind size={14} />}
                title="02 · Wave"
                body="Wave from your boat or dock — odds are good we caught it."
              />
              <Step
                icon={<Send size={14} />}
                title="03 · Ask"
                body="Email us with the day, time & location. We'll dig up the clip."
              />
            </div>

            <div className="mt-10 flex flex-wrap items-center gap-4">
              <a
                href="#book"
                data-testid="lookout-cta"
                className="inline-flex items-center gap-3 bg-[#E5A93B] hover:bg-[#FACC15] text-black px-7 py-4 text-xs font-bold uppercase tracking-[0.2em] transition-colors"
              >
                Claim your shot
                <Send size={14} />
              </a>
              <a
                href="mailto:lake.anna.aqua.aerials@gmail.com?subject=I think I was filmed on Lake Anna"
                data-testid="lookout-email"
                className="font-mono text-[11px] tracking-[0.2em] uppercase text-white/50 hover:text-[#E5A93B] transition-colors"
              >
                or email us directly →
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const Step = ({ icon, title, body }) => (
  <div className="bg-[#05080F] p-6 md:p-7">
    <div className="overline flex items-center gap-2 text-[#E5A93B]">
      {icon}
      {title}
    </div>
    <p className="mt-3 text-sm text-white/70 leading-relaxed">{body}</p>
  </div>
);
